/** sessionStorage key for beta invite code before org creation */
export const PENDING_BETA_INVITE_CODE_KEY = "pending_beta_invite_code";

/** sessionStorage key for the optional email that rode the invite deep link */
export const PENDING_BETA_INVITE_EMAIL_KEY = "pending_beta_invite_email";

/**
 * Hygiene for the optional ?email= deep-link param before it becomes an Auth0
 * login_hint: trimmed, plausibly an address, bounded. Null means "don't pass
 * anything along" — the invite flow works identically without an email.
 */
export function sanitizeBetaInviteEmail(raw: string | null): string | null {
  const email = raw?.trim() ?? "";
  if (!email || email.length > 254 || !email.includes("@")) {
    return null;
  }
  return email;
}
